import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const NON_WORKING_DAY_DELETED = gql`
  subscription nonWorkingDayDeleted {
    nonWorkingDayDeleted {
      id
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
